import * as types from "../constants/ActionTypes";

const initialState = {
  selectedDealer: undefined,
  changeDealerModal: null,
  services: null,
};

export function modifyCustomerDealer(state = initialState, action) {
  switch (action.type) {
    case 'FETCH.MY_DEALER.SUCCESS':
      return {
        ...state,
        selectedDealer: action.dealer.body,

      };
    case types.DELETE_MY_DEALER:
    case types.FETCH_CALL_CENTER_IVS_VIN_SUCCESS:
      return {
        ...state,
        selectedDealer: undefined
      }
    case 'SHOW.CHANGE_DEALER_MODAL':
      return {
        ...state,
        changeDealerModal: action.changeDealerModal,
      };
    default:
      return state
  }
}
